import { consumeAPI2, consumePostAPI2 } from '../apiClient';
import { buildFilter } from '../../services/utils/leads';

// Devuelve listado de Leads
export async function getLeads(offset = 0, contactPublisherUserId = '', limit = 25, filterIds = '') {
  const url = `/publisher/leads?offset=${offset}&limit=${limit}&contact_publisher_user_id=${contactPublisherUserId}${filterIds}`;
  return consumeAPI2(url).toPromise();
}

// Devuelve listado de Leads segun algun filtro
export async function getLeads2(queryString) {
  const url = `/publisher/leads?${queryString}`;
  return consumeAPI2(url).toPromise();
}
// Devuelve listado de actions filters
export async function getActionsLeads() {
  const url = `/publisher/leads/filters`;
  return consumeAPI2(url).toPromise();
}

// Devuelve los contadores: leads totales y no leídos
export async function getLeadStats() {
  const url = `/publisher/leads/stats`;
  return consumeAPI2(url).toPromise();
}

// Devuelve los datos del publisher logeado
export async function getPublisherData() {
  const url = `/users/me`;
  return consumeAPI2(url).toPromise();
}

// devuelve las etiquetas
export async function getLeadsStates() {
  const url = `/publisher/contact/status`;
  return consumeAPI2(url).toPromise();
}

// cambia estado de las etiquetas
export async function saveContactStatus(data, id) {
  const url = `/publisher/contact/status/${id}`;
  return consumePostAPI2(url, data).toPromise();
}

export async function markLeadStatus(status, contactIds, reason) {
  const url = `/leads/status/${status}?${buildFilter('contact_publisher_user_id', contactIds)}${buildFilter(
    'reason',
    reason
  )}`;
  return consumePostAPI2(url).toPromise();
}

export async function downloadLeads(dateFrom, dateTo, leadIds, postingId) {
  const url = `/leads/v3/export/${dateFrom}/to/${dateTo}?${postingId ? `posting_id=${postingId}` : ''}${buildFilter(
    'lead_id',
    leadIds
  )}`;
  return consumeAPI2(url).toPromise();
}
